import CompensationRequestPanel from './CompensationRequestPanel'

export default CompensationRequestPanel
